import GlobalConfig from '../lib/GlobalConfig';
class FooterConfig {
    get ANGLE_RIGHT_ICON_MOBILE() {
        return {
            url: `${GlobalConfig.cdn.SHARED_URL}/header-icons/angle-right.svg`,
            alt: 'angle right',
            placement: 'suffix',
            width: 6,
            height: 10,
        };
    }
    get FOOTER() {
        return {
            section1: {
                subSection1: [
                    {
                        title: 'Products',
                        list: [
                            {
                                name: `invideo AI`,
                                link: `https://ai.invideo.io/`,
                            },
                            {
                                name: `invideo Studio`,
                                link: `https://studio.invideo.io/`,
                            },
                        ],
                    },
                    {
                        title: 'invideo AI',
                        color: 'iv-text-hot-pink',
                        list: [
                            {
                                name: 'AI Video Generator',
                                link: 'https://invideo.io/make/ai-video-generator/',
                            },
                            {
                                name: 'AI Image Generator',
                                link: 'https://invideo.io/ai/ai-image-generator/',
                            },
                            {
                                name: 'Animation Maker',
                                link: 'https://invideo.io/make/ai-animation-generator/',
                            },
                            {
                                name: 'Link to Video',
                                link: 'https://invideo.io/make/link-to-video/',
                            },
                            {
                                name: 'Movie Maker',
                                link: 'https://invideo.io/make/online-movie-maker/',
                            },
                            {
                                name: 'AI Video Meme Generator',
                                link: 'https://invideo.io/make/meme-generator/',
                            },
                            {
                                name: 'TikTok Video Maker',
                                link: 'https://invideo.io/make/tiktok-video-editor/',
                            },
                            {
                                name: 'AI Clip Generator',
                                link: 'https://invideo.io/make/clipmaker/',
                            },
                            {
                                name: 'Youtube Shorts Maker',
                                link: 'https://invideo.io/make/ai-youtube-shorts-generator/',
                            },
                            {
                                name: 'AI Subtitle Generator',
                                link: 'https://invideo.io/make/ai-subtitle-generator/',
                            },
                            {
                                name: 'Voiceover Generator',
                                link: 'https://invideo.io/tools/ai-voiceover-generator/',
                            },
                            {
                                name: 'Slideshow Maker',
                                link: 'https://invideo.io/make/slideshow-maker/',
                            },
                        ],
                    },
                ],
                subSection2: [
                    {
                        title: `invideo Studio`,
                        list: [
                            {
                                name: 'Online Video Editor',
                                link: 'https://invideo.io/make/online-video-editor/',
                            },
                            {
                                name: 'Video Collage Maker',
                                link: 'https://invideo.io/make/video-collage-maker/',
                            },
                            {
                                name: 'Picture Video Maker',
                                link: 'https://invideo.io/make/picture-video-maker/',
                            },
                            {
                                name: 'Instagram Video Editor',
                                link: 'https://invideo.io/make/instagram-video-editor/',
                            },
                            {
                                name: 'Online Video Maker',
                                link: 'https://invideo.io/make/video-maker/',
                            },
                            {
                                name: 'Facebook Video Editor',
                                link: 'https://invideo.io/make/facebook-video-editor/',
                            },
                            {
                                name: 'Add Music to Video',
                                link: 'https://invideo.io/make/add-music-to-video-online/',
                            },
                            {
                                name: 'Add Text to GIF',
                                link: 'https://invideo.io/make/add-text-to-gif/',
                            },
                        ],
                    },
                ],
            },
            section2: {
                subSection1: [
                    {
                        title: 'Quick Tools',
                        list: [
                            {
                                name: 'Rotate Video',
                                link: `${GlobalConfig.HOST_URL}/tools/rotate-video/`,
                            },
                            {
                                name: 'Trim Video',
                                link: `${GlobalConfig.HOST_URL}/tools/video-trimmer/`,
                            },
                            {
                                name: 'Cut Video',
                                link: `${GlobalConfig.HOST_URL}/tools/video-cutter/`,
                            },
                            {
                                name: 'Video Compressor',
                                link: `${GlobalConfig.HOST_URL}/tools/compress/video-compressor/`,
                            },
                            {
                                name: 'Video Converter',
                                link: `${GlobalConfig.HOST_URL}/tools/convert/video-converter/`,
                            },
                            {
                                name: 'Screen Recorder',
                                link: `${GlobalConfig.HOST_URL}/tools/screen-recorder/`,
                            },
                        ],
                    },
                    {
                        title: 'Templates',
                        list: [
                            {
                                name: 'Marketing Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/marketing-videos/`,
                            },
                            {
                                name: 'Intro Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/intro-videos/`,
                            },
                            {
                                name: 'Real Estate Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/real-estate-videos/`,
                            },
                            {
                                name: 'Advertisement Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/advertisement-videos/`,
                            },
                            {
                                name: 'Social Media Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/social-media-videos/`,
                            },
                            {
                                name: 'View all',
                                link: `${GlobalConfig.HOST_URL}/templates/`,
                            },
                        ],
                    },
                ],
                subSection2: [
                    {
                        title: 'Help',
                        list: [
                            {
                                name: 'Live chat 24/7',
                                key: '{{footer_live_chat}}',
                            },
                            {
                                name: 'Email Us',
                                link: 'mailto:support@invideo.io',
                            },
                            {
                                name: 'Tutorials',
                                link: 'https://help.invideo.io',
                                external: true,
                            },
                            {
                                name: 'Blog',
                                link: 'https://invideo.io/blog/',
                            },
                            {
                                name: 'Youtube Channel',
                                link: 'https://www.youtube.com/channel/UCgxMiiBKk-xYskc2KNLiBTg',
                                external: true,
                            },
                            {
                                name: 'Instagram Inspiration',
                                link: 'https://www.instagram.com/invideo.io/',
                                external: true,
                            },
                            {
                                name: 'Community',
                                link: 'https://www.facebook.com/groups/invideo.io/',
                                external: true,
                            },
                        ],
                    },
                    {
                        title: 'Company',
                        list: [
                            {
                                name: 'Affiliate program',
                                link: 'https://invideo.io/make/affiliate-program/',
                                external: true,
                            },
                        ],
                    },
                    {
                        title: 'Pricing',
                        list: [
                            {
                                name: 'invideo AI',
                                link: `${GlobalConfig.HOST_URL}/pricing/`,
                            },
                            {
                                name: 'invideo Studio',
                                link: `${GlobalConfig.HOST_URL}/studio-pricing`,
                            },
                        ],
                    },
                ],
            },
        };
    }
    get FOOTER_AI() {
        return {
            section1: {
                subSection1: [
                    {
                        title: 'invideo AI',
                        color: 'iv-text-hot-pink',
                        list: [
                            {
                                name: 'AI Video Generator',
                                link: 'https://invideo.io/make/ai-video-generator/',
                            },
                            {
                                name: 'AI Image Generator',
                                link: 'https://invideo.io/ai/ai-image-generator/',
                            },
                            {
                                name: 'Animation Maker',
                                link: 'https://invideo.io/make/ai-animation-generator/',
                            },
                            {
                                name: 'Link to Video',
                                link: 'https://invideo.io/make/link-to-video/',
                            },
                            {
                                name: 'Movie Maker',
                                link: 'https://invideo.io/make/online-movie-maker/',
                            },
                            {
                                name: 'AI Video Meme Generator',
                                link: 'https://invideo.io/make/meme-generator/',
                            },
                            {
                                name: 'TikTok Video Maker',
                                link: 'https://invideo.io/make/tiktok-video-editor/',
                            },
                            {
                                name: 'AI Clip Generator',
                                link: 'https://invideo.io/make/clipmaker/',
                            },
                            {
                                name: 'Youtube Shorts Maker',
                                link: 'https://invideo.io/make/ai-youtube-shorts-generator/',
                            },
                            {
                                name: 'AI Subtitle Generator',
                                link: 'https://invideo.io/make/ai-subtitle-generator/',
                            },
                            {
                                name: 'Voiceover Generator',
                                link: 'https://invideo.io/tools/ai-voiceover-generator/',
                            },
                            {
                                name: 'Slideshow Maker',
                                link: 'https://invideo.io/make/slideshow-maker/',
                            },
                        ],
                    },
                    {
                        title: 'Mobile apps',
                        list: [
                            {
                                name: `iOS`,
                                link: `https://invideo-ai.app.link/hp-footer`,
                            },
                            {
                                name: `Android`,
                                link: `https://invideo-ai.app.link/hp-footer`,
                            },
                        ],
                    },
                ],
                subSection2: [
                    {
                        title: `invideo Studio`,
                        list: [
                            {
                                name: 'Online Video Editor',
                                link: 'https://invideo.io/make/online-video-editor/',
                            },
                            {
                                name: 'Video Collage Maker',
                                link: 'https://invideo.io/make/video-collage-maker/',
                            },
                            {
                                name: 'Picture Video Maker',
                                link: 'https://invideo.io/make/picture-video-maker/',
                            },
                            {
                                name: 'Instagram Video Editor',
                                link: 'https://invideo.io/make/instagram-video-editor/',
                            },
                            {
                                name: 'Online Video Maker',
                                link: 'https://invideo.io/make/video-maker/',
                            },
                            {
                                name: 'Facebook Video Editor',
                                link: 'https://invideo.io/make/facebook-video-editor/',
                            },
                            {
                                name: 'Add Music to Video',
                                link: 'https://invideo.io/make/add-music-to-video-online/',
                            },
                            {
                                name: 'Add Text to GIF',
                                link: 'https://invideo.io/make/add-text-to-gif/',
                            },
                        ],
                    },
                ],
            },
            section2: {
                subSection1: [
                    {
                        title: 'Quick Tools',
                        list: [
                            {
                                name: 'Rotate Video',
                                link: `${GlobalConfig.HOST_URL}/tools/rotate-video/`,
                            },
                            {
                                name: 'Trim Video',
                                link: `${GlobalConfig.HOST_URL}/tools/video-trimmer/`,
                            },
                            {
                                name: 'Cut Video',
                                link: `${GlobalConfig.HOST_URL}/tools/video-cutter/`,
                            },
                            {
                                name: 'Video Compressor',
                                link: `${GlobalConfig.HOST_URL}/tools/compress/video-compressor/`,
                            },
                            {
                                name: 'Video Converter',
                                link: `${GlobalConfig.HOST_URL}/tools/convert/video-converter/`,
                            },
                            {
                                name: 'Screen Recorder',
                                link: `${GlobalConfig.HOST_URL}/tools/screen-recorder/`,
                            },
                        ],
                    },
                    {
                        title: 'Templates',
                        list: [
                            {
                                name: 'Marketing Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/marketing-videos/`,
                            },
                            {
                                name: 'Intro Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/intro-videos/`,
                            },
                            {
                                name: 'Real Estate Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/real-estate-videos/`,
                            },
                            {
                                name: 'Advertisement Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/advertisement-videos/`,
                            },
                            {
                                name: 'Social Media Templates',
                                link: `${GlobalConfig.HOST_URL}/templates/social-media-videos/`,
                            },
                            {
                                name: 'View all',
                                link: `${GlobalConfig.HOST_URL}/templates/`,
                                icon: this.ANGLE_RIGHT_ICON_MOBILE,
                            },
                        ],
                    },
                ],
                subSection2: [
                    {
                        title: 'Help',
                        list: [
                            {
                                name: 'Live chat 24/7',
                                key: '{{footer_live_chat}}',
                            },
                            {
                                name: 'Email Us',
                                link: 'mailto:support@invideo.io',
                            },
                            {
                                name: 'Tutorials',
                                link: 'https://help-ai.invideo.io',
                                external: true,
                            },
                            {
                                name: 'Blog',
                                link: 'https://invideo.io/blog/',
                            },
                            {
                                name: 'Youtube Channel',
                                link: 'https://www.youtube.com/channel/UCgxMiiBKk-xYskc2KNLiBTg',
                                external: true,
                            },
                            {
                                name: 'Instagram Inspiration',
                                link: 'https://www.instagram.com/invideo.io/',
                                external: true,
                            },
                            {
                                name: 'Community',
                                link: 'https://discord.gg/invideo-ai',
                                external: true,
                            },
                        ],
                    },
                    {
                        title: 'Company',
                        list: [
                            {
                                name: 'Affiliate program',
                                link: 'https://invideo.io/make/affiliate-program/',
                                external: true,
                            },
                        ],
                    },
                    {
                        title: 'Pricing',
                        list: [
                            {
                                name: 'invideo AI',
                                link: `${GlobalConfig.HOST_URL}/pricing/`,
                            },
                        ],
                    },
                ],
            },
        };
    }
}
export default new FooterConfig();
